import React, { useEffect } from 'react';

import RestoreTrplTimer from './RestoreTrplTimer';
import ReplayIcon from '@mui/icons-material/Replay';

const RestoreTrplBtn = ({
  rstId,
  classes,
  ancestorId,
  deletedTid,
  setLoadingTids,
  resetDeletedTrplId,
  updateDataOnRestoreTrpl, 
  }) => {

  const hideRestore = () => {
    resetDeletedTrplId({ [rstId]: deletedTid });
  };

  useEffect(() => {
    return () => {
      hideRestore();
    }
  }, []);

  const restoreTrpl = () => {
    const dataForRequest = {id: deletedTid};
    updateDataOnRestoreTrpl(dataForRequest, ancestorId, rstId, setLoadingTids);
    hideRestore();
  };

  return (
    <div
      style={{
        alignItems: 'center',
        marginLeft: '5px',
        display: 'flex',
        cursor: 'pointer',
      }}
      onClick={() => {
        restoreTrpl();
      }}
    >
      <ReplayIcon
        style={{
          position: 'absolute',
          display: 'flex',
          width: '24px',
        }}
        className={`${classes.rstIconBtn} ${classes.rstIconBtnBlue}`}
      />
      
      <div style={{ marginLeft: '9.5px', marginTop: '3px' }}>
        <RestoreTrplTimer
          hideRestore={hideRestore}
          style={{
            display: 'block',
            position: 'relative',
            alignItems: 'center',
          }}>
        </RestoreTrplTimer>
      </div>
    </div>
  );
};

export default RestoreTrplBtn;
